export default "__VITE_ASSET__45721cf0__"